import React, { FC } from 'react';
import { FormattedDate, FormattedNumber } from 'react-intl';
import FormattedDateTime from '../format/FormattedDateTime';
import color from '../../config/color';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

interface Props {
  asset: AssetWithCalculatedStats;
  showModal: (asset: AssetWithCalculatedStats) => void;
}

const PortfolioAssetRow: FC<Props> = ({ asset, showModal }) => (
  <tr className="mouse-pointer equity-row" onClick={() => showModal(asset)}>
    <td title={asset.externalId}>{asset.name}</td>
    <td className="hide-on-991px">
      {typeof asset.totalPrice === 'number' ? (
        <FormattedNumber
          minimumFractionDigits={0}
          maximumFractionDigits={0}
          value={asset.totalPrice}
        />
      ) : (
        '-'
      )}
    </td>
    <td className="hide-on-650px">
      {asset.transactionTimestamp > 0 ? (
        <FormattedDate value={new Date(asset.transactionTimestamp)} />
      ) : (
        '-'
      )}
    </td>
    <td className="hide-on-350px">
      <FormattedDateTime
        timestamp={asset.lastUpdatedTimestamp}
        type={asset.type}
        showClockPrefix
      />
    </td>
    <td className={color.getClassName(asset.percentChange)}>
      {asset.percentChange ? (
        <FormattedNumber // eslint-disable-next-line
          style="percent"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={asset.percentChange / 100}
        />
      ) : (
        '-'
      )}
    </td>
    <td className="hide-on-374px">
      <FormattedNumber
        minimumFractionDigits={0}
        maximumFractionDigits={2}
        value={asset.price}
      />
    </td>
    <td className="hide-on-500px">
      {asset.return ? (
        <FormattedNumber
          minimumFractionDigits={0}
          maximumFractionDigits={0}
          value={asset.return}
        />
      ) : (
        '-'
      )}
    </td>
    <td className={`${color.getClassName(asset.percentReturn)} hide-on-740px`}>
      {asset.percentReturn ? (
        <FormattedNumber // eslint-disable-next-line
          style="percent"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={asset.percentReturn}
        />
      ) : (
        '-'
      )}
    </td>
    <td
      className={`${color.getClassName(
        asset.annualPercentReturn
      )} hide-on-580px`}
    >
      {asset.annualPercentReturn ? (
        <FormattedNumber // eslint-disable-next-line
          style="percent"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          value={asset.annualPercentReturn}
        />
      ) : (
        '-'
      )}
    </td>
    <td>
      {asset.totalValue ? (
        <FormattedNumber
          minimumFractionDigits={0}
          maximumFractionDigits={0}
          value={asset.totalValue}
        />
      ) : (
        '-'
      )}
    </td>
  </tr>
);

export default PortfolioAssetRow;
